import React, { useState, useEffect } from "react";
import * as Icons from "react-feather";
import { useList } from "store/list";
import { useCore } from "store/core";
import Loading from "components/Loading";
import ListSearch from "components/list/ListSearch";
import ListPagination from "components/list/ListPagination";
import Add from "./Add";
import Edit from "./Edit";
import Delete from "./Delete";
import { handleSuccessMessages } from "store/auth";
import { toJalali } from "lib/helpers";
import ListFilter from "components/list/ListFilter";
import config from "config";

export default function Matchs() {
  const path = {
    baseRoute: `/match-panel`,
    aliasName: "بازی",
    type: "Matchs",
  };
  const {
    dispatch,
    clear,
    getList,
    list,
    load,
    create,
    update,
    quickUpdate,
    remove,
    listSearch,
    from,
    to,
    total,
  } = useList();
  const { getRoles, getCountries, getProductCategories } = useCore();
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [item, setItem] = useState(false);

  useEffect(() => {
    dispatch(getList(path));
    //  dispatch(getRoles());
    //  dispatch(getProductCategories());
    //  dispatch(getCountries());
    return () => {
      dispatch(clear());
    };
  }, []);

  const filterItems = [
    {
      type: "DATE_FROM_TO",
    },
    //  {
    //    type: "FILTER",
    //    name: "filter",
    //    label: "دسترسی",
    //    options: [
    //      { label: "مدیر", value: "roles-$in-admin" },
    //      { label: "نویسنده", value: "roles-$in-author" },
    //      { label: "بازی", value: "roles-$in-user" },
    //    ],
    //  },
  ];

  return (
    <>
      <Add
        title="افزودن بازی"
        show={showAdd}
        close={() => {
          setShowAdd(false);
        }}
        submit={(values) => {
          dispatch(
            create(path, values, () => {
              handleSuccessMessages("بازی مورد نظر با موفقیت اضافه شد");
              dispatch(getList(path));
            })
          );
        }}
      />
      <Edit
        item={item}
        title="ویرایش بازی"
        show={showEdit}
        close={() => {
          setShowEdit(false);
        }}
        submit={(values, id) => {
          dispatch(
            update(path, id, values, () => {
              handleSuccessMessages("بازی مورد نظر با موفقیت ویرایش شد");
              dispatch(getList(path));
            })
          );
        }}
      />
      <Delete
        title="حذف بازی"
        show={showDelete}
        close={() => {
          setShowDelete(false);
        }}
        submite={() => {
          dispatch(
            remove(path, list, item?.id, () => {
              handleSuccessMessages("بازی مورد نظر با موفقیت حذف شد");
              dispatch(getList(path));
              setShowDelete(false);
            })
          );
        }}
      />

      <div className="content" style={{ marginBottom: 80 }}>
        <h2 className="intro-y text-lg font-medium mt-10">بازیان</h2>
        <div style={{ position: "relative", zIndex: 50 }}>
          <ListFilter path={path} items={filterItems} hasExcelReport />
        </div>
        <div className="grid grid-cols-12 gap-6 mt-5 relative z-9">
          <div className="intro-y col-span-12 flex flex-wrap sm:flex-nowrap items-center mt-2">
            <button
              onClick={() => {
                setShowAdd(true);
              }}
              className="btn btn-primary shadow-md mr-2"
            >
              افزودن بازی
            </button>
            {load && (
              <div className="hidden md:block mx-auto text-gray-600">
                در حال بارگذاری
              </div>
            )}
            {!load && (
              <div className="hidden md:block mx-auto text-gray-600">
                {`نمایش ${from} تا ${to} از ${total}`}
              </div>
            )}
            <ListSearch
              search={(key) => {
                dispatch(listSearch(path, key));
              }}
            />
          </div>

          <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
            <table className="table table-report -mt-2">
              <thead>
                <tr>
                  {/* <th className="whitespace-nowrap text-center">شناسه</th> */}

                  {/* <th className="whitespace-nowrap text-center">شماره تماس</th> */}
                  <th className="whitespace-nowrap text-center">تیم میزبان </th>
                  <th className="whitespace-nowrap text-center">تیم مهمان </th>
                  <th className="whitespace-nowrap text-center"> لیگ </th>
                  <th className="whitespace-nowrap text-center">تاریخ بازی</th>
                  <th className="whitespace-nowrap text-center"> استادیوم </th>

                  <th className="whitespace-nowrap text-center">تاریخ ثبت</th>
                  <th className="whitespace-nowrap text-center">عملیات</th>
                </tr>
              </thead>
              {load && <Loading />}
              {list && !list?.length > 0 && (
                <h3 className="w-3/6 flex justify-center">چیزی یافت نشد</h3>
              )}
              <tbody>
                {!load &&
                  list &&
                  list?.length > 0 &&
                  list?.map((item, index) => (
                    <tr key={`item_${index}`} className="intro-x">
                      {/* <td className="w-16 text-center">{item.id}</td> */}

                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item?.homeTeam?.translations?.fa?.name}
                        </p>
                      </td>
                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item?.awayTeam?.translations?.fa?.name}
                        </p>
                      </td>

                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item?.league?.translations?.fa?.name}
                        </p>
                      </td>

                      <td>
                        {" "}
                        <p className="font-medium whitespace-nowrap text-center">
                          {toJalali(item?.matchDate, "jYYYY-jMM-jDD HH:mm")}{" "}
                        </p>{" "}
                      </td>

                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item?.location?.translations?.fa?.name}
                        </p>
                      </td>

                      <td>
                        {" "}
                        <p className="font-medium whitespace-nowrap text-center">
                          {toJalali(item?.createdAt, "jYYYY-jMM-jDD HH:mm")}{" "}
                        </p>{" "}
                      </td>
                      <td className="table-report__action">
                        <div className="flex justify-center items-center">
                          <a
                            className="flex items-center ml-3 cursor-pointer"
                            onClick={() => {
                              setItem(item);
                              setShowEdit(true);
                            }}
                          >
                            {" "}
                            <Icons.CheckSquare className="w-4 h-4 ml-1" />{" "}
                            ویرایش{" "}
                          </a>
                          <a
                            className="flex items-center text-theme-6 cursor-pointer"
                            onClick={() => {
                              setItem(item);
                              setShowDelete(true);
                            }}
                          >
                            <Icons.Trash2 className="w-4 h-4 ml-1" />
                            حذف{" "}
                          </a>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <ListPagination
            getList={(page, perPage) => {
              dispatch(getList(path, page, perPage));
            }}
          />
        </div>
      </div>
    </>
  );
}
